import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxSearchPaid = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M19.863 17.714q-.738-.706-1.435-1.452c-.39-.397-.625-.685-.625-.685l-2.938-1.403a7.3 7.3 0 0 0 1.826-4.83C16.69 5.296 13.396 2 9.345 2 5.295 2 2 5.296 2 9.344c0 4.05 3.295 7.345 7.345 7.345a7.3 7.3 0 0 0 4.83-1.825l1.403 2.938s.289.235.685.625c.406.381.94.896 1.453 1.435l1.425 1.46.633.678L22 19.775l-.678-.634zM9.345 14.591A5.25 5.25 0 0 1 4.1 9.344a5.25 5.25 0 0 1 5.246-5.246 5.25 5.25 0 0 1 5.247 5.246 5.25 5.25 0 0 1-5.247 5.247"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 7.542h.75c0-1.182-1.034-1.722-1.875-1.846v-.863h-.75v.863c-.842.124-1.875.664-1.875 1.846 0 1.127 1 1.713 1.875 1.845v2.071c-.543-.104-1.125-.426-1.125-1h-.75c0 1.08.909 1.717 1.875 1.849v.86h.75v-.863c.841-.124 1.874-.664 1.874-1.846s-1.033-1.72-1.874-1.845V6.542c.498.1 1.124.392 1.124 1m-3 0c0-.608.626-.9 1.125-1v2C8.61 8.435 8 8.123 8 7.541m3 2.916c0 .608-.627.9-1.125 1v-2c.498.1 1.124.392 1.124 1"
	})]
});
export default SvgBxSearchPaid;
